import { META_IMAGES, OG_IMAGES } from '@/v2/constants/images/meta'
import { PUBLIC_MAIN_ROUTES } from '@/v2/constants/routes'
import { OGImageType } from '@/v2/types/meta'

export const ogImages: OGImageType[] = [
  {
    url: OG_IMAGES.BASE_URL.concat('/luggage-storage-services.jpg'),
    alt: 'luggage storage services page og',
    width: 1200,
    height: 630
  }
]

export const metaImages: OGImageType[] = [
  {
    url: META_IMAGES.DEFAULT,
    alt: 'luggage storage services page search image',
    width: 92,
    height: 92
  },
  ...ogImages
]

export const heroSectionContent = {
  title: 'Luggage <span>Storage Services</span> <span>The Ultimate Solution for Travelers</span>',
  description:
    'Discover ShipAndStorage’s premium luggage storage services, offering convenience, security, and accessibility for your bags & travel gear. ',
  image: {
    url: '/images/v2/pages/main-pages/luggage-storage-services/hero-image.jpg',
    alt: 'Luggage Storage Services The Ultimate Solution for Travelers'
  },
  ctaButton: { href: PUBLIC_MAIN_ROUTES.BOOK_STORAGE_FACILITY.href, text: 'Store Your Luggage' }
}

export const whyWeSectionContent = {
  title: 'How to Store Your Luggage with ShipAndStorage',
  description: 'Storing your luggage with us is simple, efficient, and designed to make your life easier.',
  ctaButton: { href: PUBLIC_MAIN_ROUTES.BOOK_STORAGE_FACILITY.href, text: 'Book Now' },

  cards: [
    {
      id: 1,
      title: 'Create an Account',
      description: 'Sign up on our platform for tailored luggage storage solutions. Getting started is quick and easy.',
      image: {
        src: '/images/v2/pages/main-pages/luggage-storage-services/create-an-account.png',
        alt: 'Create an Account'
      }
    },
    {
      id: 2,
      title: 'Prepare Your Bags',
      description: 'Pack your luggage securely, and inform us of any fragile items for extra care during storage.',
      image: {
        src: '/images/v2/pages/main-pages/luggage-storage-services/prepare-your-bags.png',
        alt: 'Prepare Your Bags'
      }
    },
    {
      id: 3,
      title: 'Schedule Pickup or Drop-Off',
      description: 'Select a convenient option to drop off your bags or schedule a pickup from your location.',
      image: {
        src: '/images/v2/pages/main-pages/luggage-storage-services/schedule-pickup-or-drop-off.png',
        alt: 'Schedule Pickup or Drop-Off'
      }
    },
    {
      id: 4,
      title: 'Relax and Access Anytime',
      description:
        'Your luggage is safely stored and accessible whenever needed, with hassle-free retrieval or delivery options.',
      image: {
        src: '/images/v2/pages/main-pages/luggage-storage-services/relax-and-access-anytime.png',
        alt: 'Relax and Access Anytime'
      }
    }
  ]
}

export const serviceTipsSectionContent = {
  title: 'Why Proper Luggage Storage Matters',
  ctaButton: { href: PUBLIC_MAIN_ROUTES.BOOK_STORAGE_FACILITY.href, text: 'Get Your Storage' },

  cards: [
    {
      id: 1,
      title: 'Protect Your Belongings',
      description:
        'Keep your luggage safe from theft or damage by storing it in a secure facility with advanced systems.',
      image: {
        src: '/images/v2/pages/main-pages/luggage-storage-services/protect-your-belongings.png',
        alt: 'Protect Your Belongings'
      }
    },
    {
      id: 2,
      title: 'Travel Light',
      description:
        'Explore freely without the burden of heavy bags. Traveling light enhances your overall experience greatly.',
      image: {
        src: '/images/v2/pages/main-pages/luggage-storage-services/travel-light.png',
        alt: 'Travel Light'
      }
    },
    {
      id: 3,
      title: 'Optimize Your Time',
      description:
        'Avoid dragging luggage around while waiting for flights or check-ins. Store your bags and save time.',
      image: {
        src: '/images/v2/pages/main-pages/luggage-storage-services/optimize-your-time.png',
        alt: 'Optimize Your Time'
      }
    },
    {
      id: 4,
      title: 'Seasonal Storage',
      description:
        'Store travel gear during off-seasons to free up space at home. Keep your essentials organized and tidy.',
      image: {
        src: '/images/v2/pages/main-pages/luggage-storage-services/seasonal-storage.png',
        alt: 'Seasonal Storage'
      }
    },
    {
      id: 5,
      title: 'Convenient Accessibility',
      description:
        'Retrieve your bags whenever needed, with flexible pickup and delivery options that fit your schedule.',
      image: {
        src: '/images/v2/pages/main-pages/luggage-storage-services/convenient-accessibility.png',
        alt: 'Convenient Accessibility'
      }
    },
    {
      id: 6,
      title: 'Protect Your Investment',
      description:
        'Quality luggage and gear are investments. Proper storage keeps them in excellent condition for years.',
      image: {
        src: '/images/v2/pages/main-pages/luggage-storage-services/protect-your-investment.png',
        alt: 'Protect Your Investment'
      }
    }
  ]
}

export const typesOfLuggageSectionContent = {
  title: 'Types of Luggage We Store',
  description: 'At ShipAndStorage, we cater to all your travel storage needs.',

  cards: [
    {
      id: 1,
      title: 'Suitcases and Travel Bags',
      description:
        'Store your suitcases, duffel bags, and backpacks securely. Our facilities are designed to accommodate bags of all sizes.',
      image: {
        src: '/images/v2/pages/main-pages/luggage-storage-services/suitcases-and-travel-bags.png',
        alt: 'Suitcases and Travel Bags'
      }
    },
    {
      id: 2,
      title: 'Carry-Ons and Personal Items',
      description:
        'Keep smaller bags, laptops, and valuables safe. Whether it’s a briefcase, tote bag, or laptop bag, we provide the perfect storage solution.',
      image: {
        src: '/images/v2/pages/main-pages/luggage-storage-services/carry-ons-and-personal-items.png',
        alt: 'Carry-Ons and Personal Items'
      }
    },
    {
      id: 3,
      title: 'Specialty Luggage',
      description:
        'We accommodate oversized items like golf bags, musical instruments, and sports equipment. No matter how unique your storage needs, we’ve got you covered.',
      image: {
        src: '/images/v2/pages/main-pages/luggage-storage-services/specialty-luggage.png',
        alt: 'Specialty Luggage'
      }
    },
    {
      id: 4,
      title: 'Travel Accessories',
      description:
        'Store items like travel pillows, umbrellas, and other essentials. Keep everything organized and ready for your next adventure.',
      image: {
        src: '/images/v2/pages/main-pages/luggage-storage-services/travel-accessories.png',
        alt: 'Travel Accessories'
      }
    }
  ]
}

export const whyChooseUsSectionContent = {
  title: 'Why Choose Us for Your Luggage Storage?',
  description: 'ShipAndStorage stands out as the most reliable and convenient option. Here’s why:',

  cards: [
    {
      id: 1,
      title: 'Flexible Storage Options',
      description: 'Pay only for what you need—enjoy short-term and long-term plans with zero hidden fees involved.',
      image: {
        src: '/images/v2/pages/main-pages/luggage-storage-services/flexible-storage-options.png',
        alt: 'Flexible Storage Options'
      }
    },
    {
      id: 2,
      title: 'Secure Facilities',
      description:
        'Our climate-controlled sites are monitored 24/7, ensuring optimal security for all your stored belongings.',
      image: {
        src: '/images/v2/pages/main-pages/luggage-storage-services/secure-facilities.png',
        alt: 'Secure Facilities'
      }
    },
    {
      id: 3,
      title: 'Convenient Accessibility',
      description:
        'Easily retrieve your items with shipping services available to your home, hotel, or even the airport.',
      image: {
        src: '/images/v2/pages/main-pages/luggage-storage-services/convenient-accessibility2.png',
        alt: 'Convenient Accessibility'
      }
    },
    {
      id: 4,
      title: 'Expert Support',
      description:
        'Get personalized assistance for oversized or delicate items along with valuable packing tips from our team.',
      image: {
        src: '/images/v2/pages/main-pages/luggage-storage-services/expert-support.png',
        alt: 'Expert Support'
      }
    },
    {
      id: 5,
      title: 'Hassle-Free Pickup & Delivery',
      description:
        'Experience simple doorstep service designed for the easy transport of heavy luggage without any stress.',
      image: {
        src: '/images/v2/pages/main-pages/luggage-storage-services/hassle-free-pickup-delivery.png',
        alt: 'Hassle-Free Pickup & Delivery'
      }
    },
    {
      id: 6,
      title: 'Affordable Pricing',
      description:
        'Enjoy competitive rates with no hidden fees, ensuring you receive high-quality services at great value.',
      image: {
        src: '/images/v2/pages/main-pages/luggage-storage-services/affordable-pricing.png',
        alt: 'Affordable Pricing'
      }
    }
  ]
}

export const promotionalBannerSectionContent = {
  id: 1,
  title: 'Convenient Luggage Storage Solutions',
  description:
    'Store your luggage with us for a seamless and stress-free experience. Whether you’re a frequent traveler or just need a place to keep luggage for a few hours, ShipAndStorage provides the perfect solution.',
  image: {
    src: '/images/v2/pages/main-pages/luggage-storage-services/convenient-luggage-storage-solutions.png',
    alt: 'Convenient Luggage Storage Solutions'
  },
  ctaButton: { href: PUBLIC_MAIN_ROUTES.MOVING_BOX_STORAGE.href, text: 'Book Now' }
}

export const faqSectionContent = {
  title: 'Frequently Asked Questions',

  questions: [
    {
      id: 1,
      question: 'What types of luggage can I store?',
      answer:
        'We accommodate a wide range of items, including suitcases, backpacks, carry-ons, and specialty luggage like sports equipment.'
    },
    {
      id: 2,
      question: 'Is my luggage safe in storage?',
      answer: 'Yes, our facilities are climate-controlled and monitored 24/7 to ensure the highest level of security.'
    },
    {
      id: 3,
      question: 'Can I access my luggage anytime?',
      answer: 'Absolutely! Your bags remain accessible whenever you need them.'
    },
    {
      id: 4,
      question: 'Do you offer pickup and delivery?',
      answer: 'Yes, we provide convenient pickup and delivery options to make storage hassle-free.'
    },
    {
      id: 5,
      question: 'How much does luggage storage cost?',
      answer: 'Pricing varies based on the duration and type of luggage stored. Contact us for a personalized quote.'
    }
  ]
}
